import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import swal from 'sweetalert';
import _ from 'lodash';
import i18next from 'i18next';
import { loginMobile } from '../api/authenticationApi';
import { resetError } from '../actions/resetAction';
import URL_PATH from '../helpers/url';
import { ERROR_MSG, SUCCESS_MSG } from '../constants/actionTypes';
// eslint-disable-next-line import/no-named-as-default
import Login from '../components/Login';
import {Loginv2}  from "../components/Loginv2";
import { OperatorPrefixes } from '../helpers/constants';
import { getLS, validateMsisdn } from '../helpers/utils';
import Footer from '../components/Footer';
import { settingAr, settingDark, settingEn } from '../helpers/translations/cssClassHelper';

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.defaultLang = window.navigator.language ? window.navigator.language : 'en';

    this.state = {
      mobileNumber: '',
      errors: {},
      isLoading: false,
      // eslint-disable-next-line react/no-unused-state
      pinSend: null,
      operatorPrefix: '',
      options: [],
      country: '',
      disabled: true,
      btnDisabled: true,
      operatorVal: '',
      // eslint-disable-next-line react/no-unused-state
      locale: this.defaultLang,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleOperatorChange = this.handleOperatorChange.bind(this);
    this.handleCountryChange = this.handleCountryChange.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if ((nextProps.pinSend === SUCCESS_MSG) || nextProps.pinSend) {
      this.setState({ errors: null });
      // eslint-disable-next-line react/destructuring-assignment
      this.props.history.push(URL_PATH.URLS.LOGIN_PIN);
    }

    if (nextProps.errors) {
      // eslint-disable-next-line react/destructuring-assignment
      if ((nextProps.errors !== this.state.errors) && (nextProps.errors === ERROR_MSG)) {
        this.setState({ isLoading: false, mobileNumber: '' });
        swal('The mobile number you entered is not registered.');
        // eslint-disable-next-line react/destructuring-assignment
        this.props.resetError();
      }
    }
  }

  getOperatorCode(val) {
    let opts;
    // eslint-disable-next-line prefer-const,react/destructuring-assignment
    opts = OperatorPrefixes.filter((obj) => obj.value === val && obj.country === this.state.country).map((obj) => ({ prefix: obj.prefix }));

    return opts[0].prefix;
  }

  // eslint-disable-next-line class-methods-use-this
  checkOperatorPrefix(val) {
    let opts;
    // eslint-disable-next-line prefer-const
    opts = OperatorPrefixes.filter((obj) => _.includes(obj.country, val)).map((obj) => ({
      prefix: obj.prefix, value: obj.value, label: obj.label, country: obj.country, img: obj.img,
    }));

    return opts;
  }

  // eslint-disable-next-line react/sort-comp
  handleChange(e) {
    // eslint-disable-next-line react/destructuring-assignment
    const getValidated = validateMsisdn(e.target.value, this.state.operatorPrefix);
    if (!getValidated && !_.isEmpty(e.target.value)) {
      this.setState({ mobileNumber: e.target.value, btnDisabled: false });
    } else {
      this.setState({ mobileNumber: e.target.value, btnDisabled: true });
    }
  }

  handleCountryChange(e) {
    let options;
    // eslint-disable-next-line prefer-const
    options = this.checkOperatorPrefix(e);
    this.setState({
      country: e, options, operatorPrefix: '', disabled: true, operatorVal: '', mobileNumber: '', btnDisabled: true,
    });
  }

  handleOperatorChange(e) {
    const operatorCode = this.getOperatorCode(e);
    this.setState({ operatorPrefix: operatorCode, disabled: false, operatorVal: e });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ isLoading: true });
    // eslint-disable-next-line react/destructuring-assignment
    const msisdn = this.state.operatorPrefix + this.state.mobileNumber;
    const { operatorPrefix } = this.state;
    const { operatorVal } = this.state;

    // eslint-disable-next-line react/destructuring-assignment
    if (!_.isEmpty(this.state.mobileNumber) && (!_.isEmpty(this.state.country) && !_.isEmpty(this.state.operatorPrefix))) {
      // eslint-disable-next-line react/destructuring-assignment
      const getValidated = validateMsisdn(this.state.mobileNumber, this.state.operatorPrefix);
      if (!getValidated) {
        // should be sending countrycode, operatorprefix,
        const data = {
          operator: operatorVal,
          msisdn,
        };
        // eslint-disable-next-line react/destructuring-assignment
        this.props.loginMobile(data);
      } else {
        swal("Your mobile number either contains the country code or there's leading 0");
        this.setState({ isLoading: false });
      }
    } else {
      // eslint-disable-next-line react/destructuring-assignment
      if (_.isEmpty(this.state.mobileNumber) && (_.isEmpty(this.state.country) && _.isEmpty(this.state.operatorPrefix))) {
        swal("You haven't entered anything yet");
        // eslint-disable-next-line react/destructuring-assignment
      } else if (_.isEmpty(this.state.country) && _.isEmpty(this.state.operatorPrefix)) {
        swal('Please select country and operator');
        // eslint-disable-next-line react/destructuring-assignment
      } else if (!_.isEmpty(this.state.country) && _.isEmpty(this.state.operatorPrefix)) {
        swal('Please select the operator');
        // eslint-disable-next-line react/destructuring-assignment
      } else if (_.isEmpty(this.state.mobileNumber)) {
        swal('Empty or Invalid mobile number entered');
      }
      // else if (_.isEmpty(this.state.operatorPrefix))
      // {
      //   swal("Please select the operator");
      // }
      this.setState({ isLoading: false });
    }
  }

  // eslint-disable-next-line react/sort-comp
  componentDidMount() {
    settingEn(i18next);
    settingDark(getLS('dark'));
  }

  // Render page goes here
  render() {
    return (
      <>
        <div id="wrapper">
          <Loginv2
            {...this.props}
            // eslint-disable-next-line react/destructuring-assignment
            isLoading={this.state.isLoading}
            // eslint-disable-next-line react/destructuring-assignment
            val={this.state.mobileNumber}
            lblInstruction="Please enter your mobile number"
            lblBtn="Sign In"
            lblBtnMsg="*Please include your country code"
            handleSubmit={this.handleSubmit}
            handleChange={this.handleChange}
            className="illustration"
            placeholder="e.g 987289090 ( without country code & a leading '0')"
            type="Login"
            lblBtnWhileLoading="Signing In"
            handleOperatorChange={this.handleOperatorChange}
            // eslint-disable-next-line react/destructuring-assignment
            options={this.state.options}
            handleCountryChange={this.handleCountryChange}
            // eslint-disable-next-line react/destructuring-assignment
            countryCode={this.state.operatorPrefix}
            // eslint-disable-next-line react/destructuring-assignment
            disabled={this.state.disabled}
            // eslint-disable-next-line react/destructuring-assignment
            btnDisabled={this.state.btnDisabled}
            propsGetValidationState={this.getValidationState}
          />

        </div>
        <Footer />
      </>

    );
  }
}

const mapStateToProps = (state) => ({
  pinSend: state.auth.pinSend,
  errors: state.errors,
});

const mapDispatchToProps = (dispatch) => ({
  loginMobile: (data) => dispatch(loginMobile(data)),
  resetError: () => dispatch(resetError()),
});

export { LoginPage };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginPage));
